/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Magnified_Download_AriaInputs */



/**
* | output |
* | --- |
* | "Download Preview Thumbnail" |
*
* @param {Video_Export_Magnified_Download_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_download_aria = /** @type {((inputs?: Video_Export_Magnified_Download_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Download_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Telecharger la miniature de previsualisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau herunterladen (Miniaturansicht)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica Anteprima Miniatura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать Предварительный просмотр Миниатюра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar vista previa en miniatura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载预览缩略图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューサムネイルをダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन थंबनेल डाउनलोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixar miniatura de pré-visualização")
	return /** @type {LocalizedString} */ ("Download Preview Thumbnail")
});